export default __webpack_public_path__ + "static/media/QR.4e2e6007.svg";